import { Checkbox, CheckboxGroup, Popover, Stack } from '@chakra-ui/react';
import { useMemo } from 'react';

import { useFilterState } from '../../hooks/useFilterState';
import { DataTableFilterOption, DataTableFilterType } from '../../utils/typings';
import { FilterPopoverButton, FilterPopoverContent } from '../FilterPopoverButton';

type Props<T extends DataTableFilterType> = {
  value: string[];
  options: DataTableFilterOption<T>[];
  onChange: (value: string[]) => void;
};

export const CheckboxFilterPopover = <T extends DataTableFilterType>({ value, options, onChange }: Props<T>) => {
  const state = useFilterState({
    defaultValue: value,
    onSubmit: onChange,
  });

  const handleChange = (nextValue: string[]) => {
    onChange(nextValue);
    state.onChange(nextValue);
  };

  const actualLabel = useMemo(() => {
    if (value?.length > 2) return `${value?.length} Selected`;

    return value?.join(', ');
  }, [value]);

  return (
    <Popover placement="bottom-start">
      <FilterPopoverButton label={actualLabel} />
      <FilterPopoverContent onClickApply={state.onSubmit} onClickCancel={state.onReset}>
        <CheckboxGroup value={state.value} onChange={handleChange}>
          <Stack>
            {options?.map((option) => (
              <Checkbox key={option?.label} value={option?.value as string}>
                {option?.label}
              </Checkbox>
            ))}
          </Stack>
        </CheckboxGroup>
      </FilterPopoverContent>
    </Popover>
  );
};
